<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import { required } from "vuelidate/lib/validators";
import Vuetable from "vuetable-2";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Swal from "sweetalert2";
import Vue from "vue";
import moment from "moment";
import axios from "axios";
import { FulfillingBouncingCircleSpinner } from "epic-spinners";

// import DatePicker from "vue2-datepicker";
import DatePicker from "vuejs-datepicker";
import "vue-select/dist/vue-select.css";
import {  es } from "vuejs-datepicker/dist/locale";
// register the plugin on vue
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import Toasted from "vue-toasted";
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.

/**
 * Categoria component
 */
export default {
  page: {
    title: "Corrales",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    DatePicker,
    PageHeader,
    Loader,
    Vuetable,
    VuetablePagination,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
  },
  data() {
    return {
        es: es,
      repit_codigo: true,
      repit: true,
      apiUrl: process.env.VUE_APP_URL,
      apiBase: process.env.VUE_APP_URL + "lotes/get",
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      arrTipoLote :[
        { nombre: 'Reemplazo' },
        { nombre: 'Gestacion' },
        { nombre: 'Lactancia' },
        { nombre: 'Destete' },
        { nombre: 'Cerdo De Engorde' },
        { nombre: 'Descarte'}
        
      ],
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
        pagination: {
          infoClass: "pull-left",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },
      mask_quetzal: createNumberMask({
          prefix: "Q ",
          suffix: "",
          includeThousandsSeparator: true,
          thousandsSeparatorSymbol: ",",
          allowDecimal: true,
          decimalSymbol: ".",
          decimalLimit: 2, // how many digits allowed after the decimal
          integerLimit: 10, // limit length of integer numbers
          allowNegative: false,
          allowLeadingZeroes: false,
      }),
      formLote: {
        no_lote: "",
        fecha_inicio: "",
        tipo_lote: "",
        state: true,
        id: 0,
      },
      updating: false,
      estadotabla: true,
      title: "Corrales",
      itemst: [
        {
          text: "Cerdos",
          href: "/",
        },
        {
          text: "Corrales",
          active: true,
        },
      ],
      fields: [
        {
          name: "no_lote",
          title: "No. Lote",
          sortField: "no_lote",
          width: "20%",
        },
        {
          name: "no_animales",
          title: "No. Animales",
          sortField: "no_animales",
          width: "20%",
        },
        {
          name: "fecha_inicio",
          title: "Fecha inicio",
          sortField: "fecha_inicio",
          width: "20%",
        },
        {
          name: "tipo_lote",
          title: "Tipo Corral",
          sortField: "tipo_lote",
          width: "20%",
        },
        {
          name: "estado",
          title: "Estado",
          titleClass: "",
          dataClass: "text-muted",
          width: "10%",
        },
        {
          name: "actions",
          title: "Acciones",
          titleClass: "",
          width: "10%",
        },
      ],
      searchType: [
        { nombre: "No. Lote", value: "no_lote" },
        { nombre: "Tipo Lote", value: "tipo_lote" }
      ],
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      banderaTipo:false,
      loadingtable: false,
      sortBy: "tipo_lote",
      sortDesc: false,
      searchLabel: { nombre: "No. Lote", value: "no_lote" },
      searchLabelLote: { nombre: "Gestacion", value: "Gestacion" },
      filterLabel: { nombre: "No. Lote", value: "no_lote" },
      showModalL: false,
      showModalN: false,
      showModalD: false,
      showModalA: false,
      showModalE: false,
      submitted: false,
      data: [],
      pageOptions: [4, 10, 15, 20],
      search: "",
      page: 1,
      perPage: 20,
      from: 0,
      to: 0,
      total: 0,
      lastPage: 0,
    };
  },
  validations: {
    formLote: {
      no_lote: {
        required,
      },
      fecha_inicio: {
        required,
      },
      tipo_lote: {
        required,
      },
    },
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
  },
  watch: {},
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,

    //modal y validaciones
    limpiarModal() {
      this.formLote.nombre = "";
      this.formLote.id = 0;
    },
    validaciones(opc) {
      this.submitted = true;
      // console.log(this.repit)
      // stop here if form is invalid

      this.$v.$touch();
      // console.log(this.$v.$invalid, this.repit);
      if (this.$v.$invalid || this.repit_codigo == false) {
        return;
      } else {
        this.showModalL = true;
        if (opc == "save") {
          this.save();
        }
        if (opc == "update") {
          this.update();
        }
      }
    },
    //Desactivar registro
    desactivate() {
      const { id, no_lote } = this.formLote;
      axios
        .put(process.env.VUE_APP_URL + "lotes/desactivate", {
          id: id,
        }, {
                headers: { "x-token": this.userT.token },
              })
        .then(() => {
          this.showModalD = false;
          Vue.toasted.error(no_lote + " Desactivado", this.options);
          const currentPage = this.$refs.vuetable.currentPage;
          
          this.$refs.vuetable.refresh(); 
          this.onChangePage(currentPage);
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          Vue.toasted.error("Error para desactivar", this.options);
        });
    },

    //ACtivar registro
    activate() {
      const { id, no_lote } = this.formLote;
      axios
        .put(process.env.VUE_APP_URL + "lotes/activate", {
          id: id,
        }, {
                headers: { "x-token": this.userT.token },
              })
        .then(() => {
          this.showModalA = false;
          Vue.toasted.info(no_lote + " Activado", this.options);
          const currentPage = this.$refs.vuetable.currentPage;
          
          this.$refs.vuetable.refresh(); 
          this.onChangePage(currentPage);
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          Vue.toasted.error("Error para activar", this.options);
        });
    },
    convertMaskToNumber(value) {
      var myNumber = "";
      for (var i = 0; i < value.length; i += 1) {
        if (
          value.charAt(i) === "Q" ||
          value.charAt(i) === "," ||
          value.charAt(i) === " "
        ) {
          continue;
        } else {
          myNumber += value.charAt(i);
        }
      } 
      return parseFloat(myNumber).toFixed(2);
    },
    //Guardar registro
    save() {
      const { no_lote,fecha_inicio, tipo_lote } = this.formLote;
      
      axios
        .post(process.env.VUE_APP_URL + "lotes/store", {
          no_lote: no_lote,
          fecha_inicio: fecha_inicio,
          tipo_lote: tipo_lote.nombre,
        }, {
                headers: { "x-token": this.userT.token },
              })
        .then(() => {
          Vue.toasted.success(no_lote + " Guardado", this.options);
          
          const currentPage = this.$refs.vuetable.currentPage;
          this.$refs.vuetable.refresh(); 
          // console.log(currentPage);
          setTimeout(() => {
            this.$refs.vuetable.changePage(currentPage); // Vuelve a la página actual
          }, 100)
          this.showModalN = false;
          this.limpiarModal();
          this.submitted = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalL = false;
        });
    },
    //ACtualizar registro
    update() {
      const { no_lote, fecha_inicio, tipo_lote, id  } = this.formLote;

      axios
        .put(process.env.VUE_APP_URL + "lotes/update", {
          id: id,
          no_lote: no_lote,
          fecha_inicio: fecha_inicio,
          tipo_lote: tipo_lote.nombre,
        }, {
                headers: { "x-token": this.userT.token },
              })
        .then(() => {
          Vue.toasted.success(no_lote + " Actualizado", this.options);
          
          const currentPage = this.$refs.vuetable.currentPage;
          this.$refs.vuetable.refresh(); 
          // console.log(currentPage);
          setTimeout(() => {
            this.$refs.vuetable.changePage(currentPage); // Vuelve a la página actual
          }, 100)

          this.showModalE = false;
          this.limpiarModal();
          this.submitted = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalL = false;
        });
    },

    //Timer de registro guardado para notificacion
    timer() {
      let timerInterval;
      Swal.fire({
        title: "Auto close alert!",
        html: "I will close in <b></b> milliseconds.",
        timer: 2000,
        timerProgressBar: true,
        onBeforeOpen: () => {
          Swal.showLoading();
          timerInterval = setInterval(() => {
            Swal.getContent().querySelector("b").textContent =
              Swal.getTimerLeft();
          }, 100);
        },
        onClose: () => {
          clearInterval(timerInterval);
        },
      }).then((result) => {
        if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.timer
        ) {
          console.log("I was closed by the timer"); // eslint-disable-line
        }
      });
    },
    //Buscador dentro de la tabala
    onFiltered() {
      this.search = this.search.toLowerCase();
      this.$refs.vuetable.refresh();
    },
    //enviar datos a la Paginacion
    onPaginationData(paginationData) {
      console.log(paginationData);
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      this.items = paginationData.data;
      this.$refs.pagination.setPaginationData(paginationData);
    },
    //Cambiar tamaño de filas en la tabala para mostrar
    changePageSize() {
      this.$refs.vuetable.refresh();
    },

    // Cambiar el valor del dropwdown para poder filtrar
    changeTypeSearch(type) {
      this.searchLabel = type;
     
        this.banderaTipo =  type.value == "tipo_lote" ? true : false;
      this.$refs.vuetable.refresh();
    },
    changeTypeSearchLote(type) {
      this.searchLabelLote = type;
      
      this.$refs.vuetable.refresh();
    },
    //Cuando cambia de pagina
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },

    //Query para realizar busquedas y ordenar
    makeQueryParams(sortOrder, currentPage) {
      return sortOrder[0]
        ? {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "createdAt",
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            tipo_lote : this.banderaTipo == true ? this.searchLabelLote.nombre : "",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          }
        : {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "createdAt",
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            tipo_lote : this.banderaTipo == true ? this.searchLabelLote.nombre : "",
            limite: this.perPage,
            search: this.search,
          };
    },
    money(value) {
      return (
          "Q " +
          parseFloat(value)
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    formatoPresentacion(date) {
      return moment(date).locale("es").format("LL");
    // return moment(date).locale("es").format("LLLL");
    },
    //Para abrir los modales y pasar los datos de la fila
    onActionClicked(action, data) {
      if (action == "edit-item") {
        this.formLote.no_lote = data.no_lote;
        this.formLote.fecha_inicio = data.fecha_inicio;
        this.formLote.tipo_lote = data.tipo_lote;
        this.formLote.id = data.id;
        this.showModalE = true;
      }
      if (action == "new-item") {
        this.formLote.no_lote = "";
        this.formLote.tipo_lote = "";
        this.formLote.fecha_inicio = "";
        this.showModalN = true;
      }
      if (action == "desactivate-item") {
        this.formLote.no_lote = data.no_lote;
        this.formLote.id = data.id;
        this.showModalD = true;
      }
      if (action == "activate-item") {
        this.formLote.no_lote = data.no_lote;
        this.formLote.id = data.id;
        this.showModalA = true;
      }
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>
<style>
/* Css para el loading en el modal */
.my-class {
  background: rgba(255, 255, 255, 0);
  color: white;
  border-bottom: 1px solid #f8f8f800;
  border: 1px solid #c02d2d00;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="itemst" />

    <div class="row">
      <div class="col-12">
        <b-modal
          centered
          v-model="showModalL"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
          no-close-on-backdrop
          content-class="my-class"
          header-class="my-class"
        >
          <template #modal-header="{}">
            <!-- Emulate built in modal header close button action -->

            <h5></h5>
          </template>
          <form>
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-center">
                  <fulfilling-bouncing-circle-spinner
                    :animation-duration="2000"
                    :size="90"
                    color="#2a3042"
                  />
                </div>
              </div>
            </div>
          </form>
        </b-modal>

        <!-- Modal para Activar -->
        <b-modal
          centered
          v-model="showModalA"
          title="Activar Concentrado"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <h4>¿Desea Activar la Concentrado?</h4>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalA = false"
                >Cancelar</b-button
              >
              <b-button variant="danger" @click="activate">Activar</b-button>
            </div>
          </form>
        </b-modal>

        <!-- Modal para Desactivar -->
        <b-modal
          centered
          v-model="showModalD"
          title="Desactivar"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <h4>¿Desea Desactivar la Concentrado?</h4>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalD = false"
                >Cancelar</b-button
              >
              <b-button variant="danger" @click="desactivate"
                >Desactivar</b-button
              >
            </div>
          </form>
        </b-modal>

        <!-- Modal para Editar-->
        <b-modal
          centered
          v-model="showModalE"
          title="Editar Lote"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form @submit.prevent="validaciones('update')">
            <div class="row">
                <div class="col-12">
                <div class="mb-3">
                  <label>Tipo Corral</label>
                  <v-select
                      v-model.trim="$v.formLote.tipo_lote.$model"
                      :state="!$v.formLote.tipo_lote.$error"
                      :options="arrTipoLote"
                      label="nombre"
                  ></v-select>
                  <div
                      :class="{
                      'invalid-feedback': true,
                      'd-block':
                        $v.formLote.tipo_lote.$error && !$v.formLote.tipo_lote.required,
                    }"
                  >
                    Debe seleccionar un tipo corral
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">No. Corral</label>
                  <input
                    id="name"
                    v-model="$v.formLote.no_lote.$model"
                    type="number"
                    class="form-control"
                    placeholder="Ingrese un no_lote"
                    :class="{
                      'is-invalid': $v.formLote.no_lote.$error,
                    }"
                    @input="$v.formLote.no_lote.$touch()"
                  />
                  <div
                    v-if="
                      $v.formLote.no_lote.$error &&
                      !$v.formLote.no_lote.required
                    "
                    class="invalid-feedback"
                  >
                    El No. Lote es obligatorio.
                  </div>
                  <!-- <div
                    v-if="!$v.formLote.no_lote.isUnique"
                    :class="{
                      'invalid-feedback': !$v.formLote.no_lote.isUnique,
                    }"
                  >
                    El no_lote de la Concentrado {{ formLote.no_lote }} ya
                    existen en nuestros registros.
                  </div> -->
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="phone">Fecha Ingreso</label>
                  <date-picker
                            v-model.trim="$v.formLote.fecha_inicio.$model"
                            :state="!$v.formLote.fecha_inicio.$error"
                             :language="es"
                                :bootstrap-styling="true"
                            :format="customFormatter"
                             input-class="form-control"
                          ></date-picker>
                          <div
                            :class="{
                              'invalid-feedback': true,
                              'd-block':
                                $v.formLote.fecha_inicio.$error &&
                                !$v.formLote.fecha_inicio.required,
                            }"
                          >
                            Debe ingresar una fecha
                          </div>
                </div>
              </div>
           
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalE = false"
                >Cerrar</b-button
              >
              <b-button type="submit" variant="success" class="ms-1"
                >Guardar</b-button
              >
            </div>
          </form>
        </b-modal>

        <!-- Modal de Nuevo Registro-->
        <b-modal
          centered
          v-model="showModalN"
          title="Nuevo Lote"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form @submit.prevent="validaciones('save')">
            <div class="row">
                <div class="col-12">
                <div class="mb-3">
                  <label>Tipo Corral</label>
                  <v-select
                      v-model.trim="$v.formLote.tipo_lote.$model"
                      :state="!$v.formLote.tipo_lote.$error"
                      :options="arrTipoLote"
                      label="nombre"
                  ></v-select>
                  <div
                      :class="{
                      'invalid-feedback': true,
                      'd-block':
                        $v.formLote.tipo_lote.$error && !$v.formLote.tipo_lote.required,
                    }"
                  >
                    Debe seleccionar un tipo corral
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">No. corral</label>
                  <input
                    id="name"
                    v-model="$v.formLote.no_lote.$model"
                    type="number"
                    class="form-control"
                    placeholder="Ingrese un no_lote"
                    :class="{
                      'is-invalid': $v.formLote.no_lote.$error,
                    }"
                    @input="$v.formLote.no_lote.$touch()"
                  />
                  <div
                    v-if="
                      $v.formLote.no_lote.$error &&
                      !$v.formLote.no_lote.required
                    "
                    class="invalid-feedback"
                  >
                    El No. Lote es obligatorio.
                  </div>
                  <!-- <div
                    v-if="!$v.formLote.no_lote.isUnique"
                    :class="{
                      'invalid-feedback': !$v.formLote.no_lote.isUnique,
                    }"
                  >
                    El no_lote de la Concentrado {{ formLote.no_lote }} ya
                    existen en nuestros registros.
                  </div> -->
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="phone">Fecha Ingreso</label>
                  <date-picker
                            v-model.trim="$v.formLote.fecha_inicio.$model"
                            :state="!$v.formLote.fecha_inicio.$error"
                             :language="es"
                                :bootstrap-styling="true"
                            :format="customFormatter"
                             input-class="form-control"
                          ></date-picker>
                          <div
                            :class="{
                              'invalid-feedback': true,
                              'd-block':
                                $v.formLote.fecha_inicio.$error &&
                                !$v.formLote.fecha_inicio.required,
                            }"
                          >
                            Debe ingresar una fecha
                          </div>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalN = false"
                >Cerrar</b-button
              >
              <b-button type="submit" variant="success" class="ms-1"
                >Guardar</b-button
              >
            </div>
          </form>
        </b-modal>

        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listado de Corrales</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-2">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Mostrar&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      @input="changePageSize()"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-2">
                <div
                  id="tickets-table_length"
                  class="dataTables_length text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    <b-dropdown v-if="searchType" id="ddown1" size="sm">
                      <template v-slot:button-content>
                        {{ "Ordenar por: " + searchLabel.nombre }}
                        <i class="mdi mdi-chevron-down"></i>
                      </template>
                      <b-dropdown-item
                        v-for="(search, index) in searchType"
                        :key="index"
                        @click="changeTypeSearch(search)"
                        >{{ search.nombre }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </label>
                  <label class="d-inline-flex align-items-center">
                    <b-dropdown v-if="banderaTipo" id="ddown1" size="sm">
                      <template v-slot:button-content>
                        {{ "Ordenar por: " + searchLabelLote.nombre }}
                        <i class="mdi mdi-chevron-down"></i>
                      </template>
                      <b-dropdown-item
                        v-for="(search, index) in arrTipoLote"
                        :key="index"
                        @click="changeTypeSearchLote(search)"
                        >{{ search.nombre }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </label>
                </div>
              </div>


              <div class="col-sm-12 col-md-3 text-md-start">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    <b-form-input
                      v-model="search"
                      type="search"
                      @input="onFiltered()"
                      placeholder="Buscar..."
                      class="form-control form-control-sm"
                    ></b-form-input>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-5">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    <button
                      type="button"
                      class="btn btn-success btn-rounded mb-2 me-2"
                      @click="onActionClicked('new-item')"
                    >
                      <i class="mdi mdi-plus me-1"></i> Nuevo Corral
                    </button>
                  </label>
                </div>
              </div>

              <!-- End search -->
            </div>
            <!-- Table -->
            <Loader :loading="loadingtable">
              <vuetable
                ref="vuetable"
                class="table-divided table-responsive order-with-arrow"
                :css="css.table"
                :api-url="apiBase"
                :reactive-api-url="true"
                :fields="fields"
                :http-options="httpOptions"
                :per-page="perPage"
                :query-params="makeQueryParams"
                pagination-path
                @vuetable:pagination-data="onPaginationData"
              >
                <div slot="actions" slot-scope="props">
                  <b-button-group class="mt-4 mt-md-0">
                    <b-button
                      v-if="props.rowData.estado"
                      tabindex="0"
                      v-b-tooltip.focus
                      title="Editar"
                      variant="outline-primary"
                      @click="onActionClicked('edit-item', props.rowData)"
                      ><i class="bx bx-edit-alt"></i>
                    </b-button>

                    <b-button
                      tabindex="0"
                      v-b-tooltip.focus
                      title="Cambiar Estado"
                      :variant="
                        props.rowData.estado == true
                          ? 'outline-danger'
                          : 'outline-success'
                      "
                      @click="
                        props.rowData.estado == true
                          ? onActionClicked('desactivate-item', props.rowData)
                          : onActionClicked('activate-item', props.rowData)
                      "
                    >
                      <i
                        :class="
                          props.rowData.estado == true
                            ? 'bx bx-trash-alt'
                            : 'bx bx-list-check'
                        "
                      ></i>
                    </b-button>
                  </b-button-group>
                </div>

                <div slot="estado" slot-scope="props">
                  <h5 v-if="props.rowData.estado == true">
                    <span class="badge bg-success ms-1"
                      ><strong>ACTIVO</strong></span
                    >
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-danger ms-1"
                      ><strong>INACTIVO</strong></span
                    >
                  </h5>
                </div>
                <div slot="fecha_inicio" slot-scope="props">
                  {{
                    formatoPresentacion(props.rowData.fecha_inicio)
                  }}
                </div>
              </vuetable>
              <div style="padding-top: 10px">
                <vuetable-pagination
                  ref="pagination"
                  :css="css.pagination"
                  @vuetable-pagination:change-page="onChangePage"
                ></vuetable-pagination>
              </div>
            </Loader>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>./concentrado.vue
